module.exports = __webpack_public_path__ + "static/media/property-purse-logo-gold.9c45b6d1.png";